import React from "react";
import Sidebar from "../reusable/Sidebar";
import axios from "axios";
import parse from "html-react-parser";
import { useNavigate, useParams } from "react-router-dom";
const GLOBAL = require('../../commonConstants.js');

const assetUrl = GLOBAL.assetUrl;
const news = GLOBAL.BASE_URL + "newsDetails/";

function SharedNewsDetail() {
  const slug = useParams();
  const navigate = useNavigate();
  const [getNews, setNews] = React.useState(null);

  React.useEffect(() => {
    axios.get(news + slug.id).then((response) => {
      setNews(response.data);
    });
  }, [slug.id]);

  if (!getNews) return null;

  return (
    <>
      <section
        className="isgf-breadcum isgf_grid_modernization_breadcum"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/grid-modernization/grid-modernization-banner.jpg"})`,
        }}
      >
        <div className="container">
          <div className="isgf-breadcum-box">
            <h1>{getNews.title}</h1>
            <p>
              Home {">"} ISGF {">"} Shared News {">"} {getNews.title}
            </p>
          </div>
        </div>
      </section>
      <section className="grid_modernization">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="heading mb-3">
                <h2>{getNews.title}</h2>
              </div>
              <div className="grid_modernization_topbox mb-3">
                <div className="row g-4">
                  <div className="col-md-3">
                    <img
                      src={assetUrl + "/public/news_img/" + getNews.image}
                      alt="pic"
                    />
                  </div>
                  <div className="col-md-9">
                    {getNews.description != null ? (
                      <>{parse(`${getNews.description}`)}</>
                    ) : (
                      <></>
                    )}
                    <div className="mt-3 r-more">
                      <span><i className="text-green fa fa-file"></i> Read More:</span>{" "}
                      <a href={getNews.read_more} target="_blank" rel="noreferrer">
                        {getNews.read_more}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-md-12">
                  <a onClick={() => navigate(-1)} className="btn btn-blue btn-previous">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/grid-modernization/privew.png`}
                      className="previous-img"
                      alt="Previous"
                    />{" "}
                    Previous
                  </a>
                </div>
              </div> */}
            </div>
            <div className="col-lg-4">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SharedNewsDetail;
